/* eslint-disable @typescript-eslint/naming-convention */
export class Stakeholder {
    StakeholdersId: number;
    Name: string;
    Description: string;
    EmailAddress: string;
    EmailAddressUrgent: string;
    EmailAddressCc: string;
    EmailAddressBcc: string;
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}

/* eslint-disable @typescript-eslint/naming-convention */
export class AllStakeholderRow {
    StakeholderId: number | null;
    StakeholdersName: string;
    Description: string;
    EmailAddress: string;
    EmailAddressUrgent: string;
    EmailAddressCc: string;
    EmailAddressBcc: string;
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}

export class AllStakeholderGrid {
    Rows: AllStakeholderRow[] = [];
}
